var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.Input,{ref:"inputRef",attrs:{"state-key":_setup.usingStateKey},on:{"change":_setup.handleChange}},[(_setup.state.conf.enableScan === 'Y')?_c(_setup.Scan,{attrs:{"slot":"suffix"},on:{"scan":_setup.handleScan},slot:"suffix"}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }